import React from 'react'
import { Flex } from 'ui/acro'
import AloMovesAnimation from 'components_v2/Search/common/AloMovesAnimation'

const LoaderPlaylist = () => {
  return (
    <Flex flexDirection='column' gap='18px' flex='1'>
      <AloMovesAnimation />
    </Flex>
  )
}
LoaderPlaylist.propTypes = {}

export default LoaderPlaylist
